import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartPie,
  faCubes,
  faChartLine,
  faProjectDiagram,
  faHeadset,
  faCog,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { handlingApi } from "units/handlingApi";
import toast from "react-hot-toast";
import Cookies from "js-cookie";

const Sidebar = ({ activeItem }) => {
  const navigate = useNavigate()
  const menuItems = [
    { icon: faChartPie, id: "dashboard",path:"/admin/dashboard" },
    // { icon: faCubes, id: "inventory" },
    // { icon: faChartLine, id: "analytics" },
    // { icon: faProjectDiagram, id: "projects" },
    // { icon: faHeadset, id: "support" },
  ];

  const adminSignOut = async()=>{
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}user/admin-signout`;

      const adminToken = Cookies.get("adminToken");
      
      const res = await handlingApi({ url, method: "POST", data: {}, token: adminToken });

      if (res.statusCode === 200) {
        toast.success(res.message)
        Cookies.remove("adminToken")
        localStorage.removeItem("adminUserData")
        navigate("/admin/login")
      }

    } catch (error) {
      console.error(error)
    }
  }

  const handleRedirect = (id) => {
    navigate(`/admin/${id}`)
  }

  const bottomItems = [
    { icon: faCog, id: "settings", onClick : () => handleRedirect("settings") },
    { icon: faSignOutAlt, id: "logout", title: "Logout", onClick: adminSignOut },
  ];

  return (
    <>
      <div className="sidebar">
        <div className="logo" onClick={() => navigate("/")}>
          <img src="/newFavicon.png" alt="Logo" />
        </div>
        <div className="sidebar-menu">
          {menuItems.map((item) => (
            <Link
              to={item.path}
              key={item.id}
              className={`sidebar-item ${
                activeItem === item.id ? "active" : ""
              }`}
            >
              <FontAwesomeIcon icon={item.icon} />
            </Link>
          ))}
        </div>
        <div className="sidebar-bottom">
          {bottomItems.map((item) => (
            <div key={item.id} onClick={item.onClick} title={item.title} className="sidebar-item">
              <FontAwesomeIcon icon={item.icon} />
            </div>
          ))}
        </div>
      </div>
      <div className="top-bar">
        <div className="brand">
          <h3>Strafinfo Admin</h3>
        </div>
        <div className="nav-menu">
          <NavLink to = "/admin/dashboard" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>DASHBOARDS</NavLink>
          {/* <NavLink to = "/admin/orders" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>Orders</NavLink> */}
          <NavLink to = "/admin/users-info" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>Users</NavLink>
          <NavLink to = "/admin/form" className={({ isActive }) => (isActive ? "nav-item active" : "nav-item")}>Form Data</NavLink>
          {/* <div className="nav-item">CRM System</div>
                        <div className="nav-item">
                            Ecommerce
                            <span className="badge badge-danger">2</span>
                        </div> */}
          {/* <div className="nav-item">Analytics</div> */}
          {/* <div className="nav-item">Project Management</div> */}
          {/* <div className="nav-item">Helpdesk Management</div> */}
        </div>
        {/* <div className="nav-heading">CONTACTS</div>
                    <div className="contact-list">
                        <div className="contact-item">
                            <div className="contact-avatar">
                                <img src="https://placeholder.com/30" alt="Valentine Maton" />
                            </div>
                            <div className="contact-name">Valentine Maton</div>
                        </div>
                        <div className="contact-item">
                            <div className="contact-avatar">
                                <img src="https://placeholder.com/30" alt="Holmes Cherryman" />
                            </div>
                            <div className="contact-name">Holmes Cherryman</div>
                        </div>
                        <div className="contact-item">
                            <div className="contact-avatar">
                                <img src="https://placeholder.com/30" alt="Kenneth Hune" />
                            </div>
                            <div className="contact-name">Kenneth Hune</div>
                        </div>
                    </div> */}
        {/* <div className="nav-heading">FOLLOWERS</div>
        <div className="follower-avatars">
          <div className="follower-avatar bg-success">E</div>
          <div className="follower-avatar bg-info">C</div>
          <div className="follower-avatar bg-dark">+30</div>
        </div> */}
      </div>
    </>
  );
};

export default Sidebar;
